type UserRole = TestRequestRaw.Schemas.Role;

export const userRoleDictionary: { [R in UserRole]: string } = {
  USER: "User",
  ADMIN: "Admin",
  REQUESTER: "Requester",
  EXTENDED_REQUESTER: "Extended Requester",
  STAKEHOLDER: "Stakeholder",
  KEY_USER: "Key User",
  TMB_KEY_USER: "TMB Key User",
  BLOX_APPLICATION: "BLOX",
  CRM_APPLICATION: "CRM",
  SNOWFLAKE_APPLICATION: "Snowflake Application",
  MARKETING: "Marketing",
  LABORATORY_MANAGER: "Laboratory Manager",
};

export const userRoleOptions: UserRole[] = [
  "USER",
  "ADMIN",
  "REQUESTER",
  "EXTENDED_REQUESTER",
  "STAKEHOLDER",
  "KEY_USER",
  "TMB_KEY_USER",
  "BLOX_APPLICATION",
  "CRM_APPLICATION",
  "SNOWFLAKE_APPLICATION",
  "MARKETING",
  "LABORATORY_MANAGER",
];

export default UserRole;
